import { createEnum } from "@redotech/zod-util/zod-enum";

// The delay lets ShipHero finish syncing a new exchange order before Redo holds
// it, so the hold sticks instead of racing ShipHero's import.
export const SHIPHERO_EXCHANGE_HOLD_DELAY_DEFAULT_SECONDS = 45;

export enum ShipheroReturnStatus {
  COMPLETE = "complete",
  WAREHOUSE_COMPLETE = "warehouse complete",
  PENDING = "pending",
}

export const ShipheroReturnStatusZodSchema = createEnum(ShipheroReturnStatus, {
  enumName: "ShipheroReturnStatus",
});
